import type { PaigeClient } from '@paige/api-client';
import type { AdminApi } from './data-source';
import type { FlowHistory, FlowIncidentCompaniesPage, FlowIncidents, SupportFiles } from './types';
import { tenantHeader, unwrap } from './http';

/** Stages and queues' incidents (`/admin/flow/incidents`): the causes, and one cause's companies. */
export function flowIncidentsApi(
  client: PaigeClient,
): Pick<
  AdminApi,
  'listFlowIncidents' | 'listFlowIncidentCompanies' | 'getFlowHistory' | 'listBatchFiles'
> {
  return {
    async getFlowHistory(minutes) {
      const r = await client.GET('/admin/flow/history', { params: { query: { minutes } } });
      return unwrap(r) as FlowHistory;
    },
    async listBatchFiles(tenantId, batchId) {
      const r = await client.GET('/batches/{batchId}/files', {
        params: { path: { batchId }, header: tenantHeader(tenantId) },
      });
      return unwrap(r) as SupportFiles;
    },
    async listFlowIncidents(company) {
      const r = await client.GET('/admin/flow/incidents', {
        params: { query: company ? { company } : {} },
      });
      return unwrap(r) as FlowIncidents;
    },
    async listFlowIncidentCompanies(incident, company, offset) {
      const query = {
        class: incident.class,
        offset,
        limit: 5,
        ...(incident.class === 'slow' ? { place: incident.origin } : {}),
        ...(incident.reason && incident.class !== 'slow' ? { reason: incident.reason } : {}),
        ...(company ? { company } : {}),
      };
      const r = await client.GET('/admin/flow/incidents/companies', { params: { query } });
      return unwrap(r) as FlowIncidentCompaniesPage;
    },
  };
}
